import { dsl } from '@wix/yoshi-serverless/wrap';

export const fetch = dsl({
          functionName: 'fetch',
          fileName: 'api/media/media.api',
        });